import axios from 'axios';
export const API=process.env.REACT_APP_BACKEND_URL+'/api';
export const api=axios.create({baseURL:API});
api.interceptors.request.use(config=>{const token=localStorage.getItem('mt-session');if(token)config.headers.Authorization='Bearer '+token;return config;});
let sessionPromise;
export async function ensureSession(){
  if(localStorage.getItem('mt-session'))return;
  if(!sessionPromise)sessionPromise=api.post('/session').then(({data})=>localStorage.setItem('mt-session',data.token)).finally(()=>{sessionPromise=null;});
  return sessionPromise;
}
export function errorText(err){const detail=err.response?.data?.detail;return typeof detail==='string'?detail:'Something went wrong. Please try again.';}
export const money=value=>new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:Number.isInteger(value)?0:2}).format(value);
export async function downloadInvoice(id){
  const {data}=await api.get(`/engagements/${id}/invoice`,{responseType:'blob'});
  const url=URL.createObjectURL(data);const a=document.createElement('a');a.href=url;a.download=id+'-invoice.pdf';a.click();setTimeout(()=>URL.revokeObjectURL(url),1000);
}